import { render, staticRenderFns } from "./grid.vue?vue&type=template&id=712f8f20&"
import script from "./grid.vue?vue&type=script&lang=js&"
export * from "./grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports